import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss']
})
export class PrincipalComponent implements OnInit {

  constructor(
    private router: Router
  ) { 
    this.router.navigate(['/profile/kkrishnaveni']);
  }

  ngOnInit(): void {
  }
}
